"use client"
import React, { useState } from "react"
import { cancelSubscription } from "../../../../../services/billing"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const CancelModal = ({ show, onClose }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1)
  const [reason, setReason] = useState("")
  const [feedback, setFeedback] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  if (!show) return null

  const handleNext = () => {
    if (step === 1 && !reason) return setError("⚠️ Please select a reason")
    if (step === 2 && !feedback.trim()) return setError("⚠️ Please enter feedback")
    setError("")
    setStep(step + 1)
  }

  const handleBack = () => {
    setError("")
    setStep(step - 1)
  }

  const handleSubmit = async () => {
    if (!reason) return setError("⚠️ Reason is required")
    try {
      setLoading(true)
      const response = await cancelSubscription({ reason, feedback })
      toast.success(response.data.message || "Subscription cancelled successfully", {
        position: "bottom-right",
      });
      navigate('/dashboard')
      closeModal()
    } catch (err) {
      console.error('Failed to subscription cancel api : ', err)
    } finally {
      setLoading(false)
    }
  }

  const closeModal = () => {
    setStep(1)
    setReason("")
    setFeedback("")
    setError("")
    setLoading(false)
    onClose()
  }

  return (
    <div
      className="modal d-flex align-items-center justify-content-center"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1052,
      }}
      onClick={closeModal}
    >
      <div
        key={step}
        className="modal-dialog modal-lg animate-flip"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-semibold">Cancel Subscription</h5>
            <div className="modal-close-btn">
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
          </div>
          <div className="modal-body p-4">
            {error && <div className="alert alert-danger py-2">{error}</div>}

            {/* Step 1: Reason */}
            {step === 1 && (
              <>
                <label className="form-label">Why are you canceling?</label>
                <select
                  className="form-select mb-3"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value="">Select a reason...</option>
                  <option value="Too expensive">Too expensive</option>
                  <option value="Not using the service">Not using the service</option>
                  <option value="Found a better alternative">Found a better alternative</option>
                  <option value="Technical issues">Technical issues</option>
                  <option value="Other">Other</option>
                </select>
                <div className="d-flex">
                  <button className="btn btn-outline-secondary me-2 flex-fill" onClick={closeModal}>
                    Cancel
                  </button>
                  <button className="btn cancel-btn flex-fill" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 2: Feedback */}
            {step === 2 && (
              <>
                <label className="form-label">How can we improve?</label>
                <textarea
                  className="form-control mb-3"
                  rows="3"
                  placeholder="Your feedback helps us improve our service..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <div className="d-flex">
                  <button className="btn btn-secondary me-2 flex-fill" onClick={handleBack}>
                    Back
                  </button>
                  <button className="btn cancel-btn flex-fill" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </>
            )}

            {/* Step 3: Confirmation */}
            {step === 3 && (
              <>
                <div className="alert alert-warning">
                  ⚠️ Canceling will permanently delete all your data and cannot be undone.
                </div>
                <div className="d-flex">
                  <button className="btn btn-secondary me-2 flex-fill" onClick={handleBack}>
                    Back
                  </button>
                  <button className="btn cancel-btn flex-fill" onClick={handleNext}>
                    Continue
                  </button>
                </div>
              </>
            )}

            {/* Step 4: Final Cancel */}
            {step === 4 && (
              <div className="d-flex flex-column">
                <p className="text-center mb-4">Confirm to cancel your subscription.</p>
                <div className="d-flex">
                  <button className="btn btn-secondary me-2 flex-fill" onClick={handleBack}>
                    Back
                  </button>
                  <button className="btn cancel-btn flex-fill" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Cancelling..." : "Cancel Subscription"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CancelModal
